import { api } from "@/features/utils/fetch-server";
import type {
  CreateScheduleRequest,
  CreateTimeOffRequest,
  Schedule,
  TimeOff,
  UpdateScheduleRequest,
  UpdateTimeOffRequest,
} from "../types";

export class SchedulesAPI {
  // Schedules
  static async listSchedules(clientId: string) {
    const response = await api.get<{ schedules: Schedule[] }>(
      `/api/calendars/v1/${clientId}/schedules`,
    );
    return response.schedules;
  }

  static async getSchedule(clientId: string, scheduleId: string) {
    const response = await api.get<{
      schedule: Schedule;
    }>(`/api/calendars/v1/${clientId}/schedules/${scheduleId}`);
    return response.schedule;
  }

  static async createSchedule(clientId: string, data: CreateScheduleRequest) {
    const response = await api.post<
      {
        schedule: Schedule;
      },
      CreateScheduleRequest
    >(`/api/calendars/v1/${clientId}/schedules`, data);
    return response.schedule;
  }

  static async updateSchedule(
    clientId: string,
    scheduleId: string,
    data: UpdateScheduleRequest,
  ) {
    const response = await api.put<
      { schedule: Schedule },
      UpdateScheduleRequest
    >(`/api/calendars/v1/${clientId}/schedules/${scheduleId}`, data);
    return response.schedule;
  }

  static async deleteSchedule(
    clientId: string,
    scheduleId: string,
  ): Promise<void> {
    await api.delete(`/api/calendars/v1/${clientId}/schedules/${scheduleId}`);
  }

  static async setDefaultSchedule(
    clientId: string,
    scheduleId: string,
  ): Promise<Schedule> {
    const response = await api.post<{ schedule: Schedule }, void>(
      `/api/calendars/v1/${clientId}/schedules/${scheduleId}/set-default`,
    );
    return response.schedule;
  }

  // Time-offs
  static async listTimeOffs(clientId: string) {
    const response = await api.get<{ timeoffs: TimeOff[] }>(
      `/api/calendars/v1/${clientId}/timeoffs`,
    );
    return response.timeoffs;
  }

  static async getTimeOff(clientId: string, timeoffId: string) {
    const response = await api.get<{
      timeoff: TimeOff;
    }>(`/api/calendars/v1/${clientId}/timeoffs/${timeoffId}`);
    return response.timeoff;
  }

  static async createTimeOff(clientId: string, data: CreateTimeOffRequest) {
    const response = await api.post<
      {
        timeoff: TimeOff;
      },
      CreateTimeOffRequest
    >(`/api/calendars/v1/${clientId}/timeoffs`, data);
    return response.timeoff;
  }

  static async updateTimeOff(
    clientId: string,
    timeoffId: string,
    data: UpdateTimeOffRequest,
  ) {
    const response = await api.put<{ timeoff: TimeOff }, UpdateTimeOffRequest>(
      `/api/calendars/v1/${clientId}/timeoffs/${timeoffId}`,
      data,
    );
    return response.timeoff;
  }

  static async deleteTimeOff(
    clientId: string,
    timeoffId: string,
  ): Promise<void> {
    await api.delete(`/api/calendars/v1/${clientId}/timeoffs/${timeoffId}`);
  }
}
